import type { Resource } from '../../';
export const forms_error_mustBeTrue: Resource = {"default":"Please agree to the terms to continue."};
